<template>
    <BlockContainer
        :id="'image-content-' + slugify(data.heading)"
        :background-color="data.backgroundColor"
        :bottom-angle="data.bottomAngle"
        :angle-background-color="data.nextBackgroundColor"
        :arrow-callout="data.arrowCallout"
    >
        <div
            :id="slugify(data.heading)"
            class="grid gap-x-16 py-14 md:grid-cols-2 lg:py-28"
        >
            <div class="flex flex-col justify-end">
                <h2 v-if="data.heading" class="pb-4">
                    {{ data.heading }}
                </h2>
                <h3
                    v-if="data.subheading"
                    class="pb-4"
                    :class="[
                        data.subheadingColor
                            ? 'text-' + data.subheadingColor
                            : data.backgroundColor == 'light-blue'
                              ? 'text-grind'
                              : 'text-drip',
                    ]"
                >
                    {{ data.subheading }}
                </h3>
                <WysiwygContent :content="data.description" class="mb-4" />
                <div
                    v-for="(bulletPoint, index) in data.bulletPoints"
                    class="mb-2"
                >
                    <img
                        :src="bulletPoint.src"
                        :alt="bulletPoint.alt"
                        class="relative mr-2 inline-block w-[20px] rounded-lg"
                    />
                    {{ bulletPoint.title }}
                </div>
            </div>
            <div class="order-last">
                <div v-if="data.buttons" class="gap-x-2 md:flex">
                    <Button
                        v-for="(button, key) in data.buttons"
                        :key="key"
                        :button="button"
                        class="w-full md:w-auto"
                    />
                </div>
            </div>
            <div
                class="flex items-center justify-center py-6 md:row-span-2 md:row-start-1"
                :class="[
                    data.reverseLayout ? 'md:col-start-1' : 'md:col-start-2',
                ]"
            >
                <div class="image-wrapper relative">
                    <div
                        class="absolute inset-0 rounded-lg bg-gray-100 blur"
                    ></div>
                    <StoryblokImage
                        v-if="data.image"
                        :src="data.image.src"
                        :alt="data.image.alt"
                        class="relative rounded-lg border border-gray-100 bg-white"
                        :sizes="
                            data.reverseLayout
                                ? '360px lg:766px'
                                : '360px lg:718px'
                        "
                        :image-width="data.reverseLayout ? 766 : 718"
                        :preload="false"
                        :quality="95"
                    />
                </div>
            </div>
        </div>
    </BlockContainer>
</template>

<script setup lang="ts">
import type { ImageContentType } from '#shared/types/ImageContentType';
import BlockContainer from '~/components/BlockContainer.vue';
import Button from '~/components/page-building/components/Button.vue';

defineProps<{
    data: ImageContentType;
}>();
</script>
